module.exports = __webpack_public_path__ + "static/1289084512.39c2fbf0.jpg";